import { LayerDefinition } from './types';

export const cloudInversionDefinition: LayerDefinition = {
  id: 'cloud_inversion',
  name: 'Cloud Inversion / Sea of Clouds',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🏔️',
  description: `A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic "Sea of Clouds" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.

This layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.

Low clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.

Designed specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.`,
  scoreDescription: `• Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.
• Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.
• Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.
• Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.`,
  sourceModels: ['nbm'],
  outputModels: ['Cloud Inversion / Sea of Clouds (.pmtiles)'],
  config: {
    defaultModel: 'nbm'
  }
};

export default cloudInversionDefinition;
